var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.003,
    height: 14,
    viewBox: "0 0 14.003 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3154",
    "data-name": "Group 3154",
    transform: "translate(-882 -688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Instagram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3150",
    "data-name": "Group 3150",
    transform: "translate(0 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(882 710.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "instagram-_167_",
    "data-name": "instagram-[#167]",
    d: "M288.11,7279.084a3.864,3.864,0,0,0-4.053,4.046c-.032.7-.22,6.022.323,7.416a3.524,3.524,0,0,0,2.038,2.03,4.9,4.9,0,0,0,1.691.322c6.2.28,8.5.133,9.473-2.352a5.056,5.056,0,0,0,.323-1.688c.284-6.217-.046-7.568-1.127-8.646-.858-.854-1.867-1.435-8.669-1.127m.057,12.567a4.094,4.094,0,0,1-1.294-.238,2.3,2.3,0,0,1-1.322-1.323c-.414-1.057-.277-6.091-.239-6.9a2.984,2.984,0,0,1,.76-2.093c.7-.693,1.6-1.037,7.726-.756a2.987,2.987,0,0,1,2.095.756c.7.693,1.043,1.6.761,7.708a3.81,3.81,0,0,1-.239,1.288c-.631,1.617-2.082,1.841-8.247,1.561m5.7-9.368a.836.836,0,1,0,.836-.833.833.833,0,0,0-.836.833M287.4,7286a3.577,3.577,0,1,0,3.577-3.571A3.571,3.571,0,0,0,287.4,7286m1.255,0a2.322,2.322,0,1,1,2.322,2.317A2.318,2.318,0,0,1,288.66,7286",
    transform: "translate(-284 -7279.001)",
    fill: "#949494",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_981",
    "data-name": "Rectangle 981",
    width: 14,
    height: 14,
    transform: "translate(882 711)",
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.dcc4fe85e33c1181a2a6a480a9119141.svg";
export { ForwardRef as ReactComponent };